import React, { useState } from "react";
import { renderToString } from "react-dom/server";
import { SSUMenu } from "../SSUMenu";
import { Avatar, Button, Card, Drawer, List, Space, Tag } from "antd";
import ModalComponent from "../../../components/UI/Modal/Modal";
import "./YearlyPlan.css";
import moment from "moment";
import { YPForm } from "./YPForm";
import { Spinner } from "react-bootstrap";
import axiosInstance from "../../../api/utils/axiosInstance";
import { toast } from "react-toastify";
import { YEAR_PLAN_TYPE } from "../../../constants";
import { ApproveModal } from "../../../components/StrucnaUsavrsavanja/ApproveModal";
import fillOutTemplate from "../Organizatori/EducationViewTemplate";
import { YearPlanDeadlineDetails } from "../../../components/StrucnaUsavrsavanja/YearPlanDeadlineDetails";
import { FilePdfOutlined, PrinterOutlined } from "@ant-design/icons";

const INIT_FORM_DATA = {
  year: null,
  id: null,
  idOrganizer: null,
  approval: false,
  educations:[],
  type: YEAR_PLAN_TYPE.main,
}

//TODO:vidi sta ces tu nakraju, mislim da se ne bi trebali moci uređivat već "istekli" godisnji planovi
export const YearlyPlan = ({hideCreateBtn, hideMenuItems, fetchBtnTitle, isApprovalAction, forOrganizer}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [plansData, setPlansData] = useState([]);
  const [additionalPlansData, setAdditionalPlansData] = useState([]);
  const [isPlansDrawerOpen, setIsPlansDrawerOpen] = useState(false);
  const [isChildDrawerOpen, setIsChildDrawerOpen] = useState(false);
  const [childDrawerData, setChildDrawerData] = useState(INIT_FORM_DATA);
  

  const fetchAllPlans = async () => {
    setIsLoading(true);
    try {
      let url = "/organizer/yp/all".concat(forOrganizer ? `?forOrganizer=${forOrganizer.oib}` : "");
      const res = await axiosInstance.get(url);
      res.data.sort((a,b) => b.year - a.year);
      const mainPlans = res.data.filter(plan => plan.type === YEAR_PLAN_TYPE.main);
      const additionalPlans = res.data.filter(plan => plan.type === YEAR_PLAN_TYPE.additional);
      setPlansData(mainPlans);
      setAdditionalPlansData(additionalPlans);
    } catch (e) {
      console.log(e);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchAllPlansAndOpenDrawer = () => {
    fetchAllPlans();
    setIsPlansDrawerOpen(true);
  }

  const closePlansDrawer = () => {
    setPlansData([]);
    setChildDrawerData(INIT_FORM_DATA);
    setIsPlansDrawerOpen(false);
  }

  const showChildDrawer = (id) => {
      setChildDrawerData(plansData.filter((plan) => plan.id === id)[0]);
      setIsChildDrawerOpen(true);
  };

  const closeChildDrawer = () => {
    fetchAllPlans();
    setChildDrawerData(INIT_FORM_DATA);
    setIsChildDrawerOpen(false);
  }

  const handleAdditionalBtn = (mainYearlyPlan) => {
    const found = additionalPlansData.filter(plan => plan.year === mainYearlyPlan.year)[0];
    if(!!found){
      setChildDrawerData(found);
      setIsChildDrawerOpen(true);
    }else{
      toast.error("Nije kreiran dodatni pojedinačni program za odabranu godinu.", {position: toast.POSITION.BOTTOM_RIGHT});
    }
  }

  const getDrawerTitle = () => {
    let tempTitle="";
    switch(childDrawerData.type){
      case YEAR_PLAN_TYPE.main:
        tempTitle=`Godišnji plan za ${childDrawerData.year} `;
        break;
      case YEAR_PLAN_TYPE.additional:
        tempTitle=`Dodatni pojedinačni plan za ${childDrawerData.year} `;
        break;
    }
    return (
      <>
        {tempTitle}
        <Tag color={childDrawerData.approval ? "green" : "red"}>{childDrawerData.approval ? "Odobreno": "Neodobreno"}</Tag>
      </>
    )
  }

  function printPage() {
    const style =  `<style>
        body { font-family: Arial, sans-serif; margin: 20px; }
        table { border-collapse: collapse; width: 100%; }
        th, td { text-align: left; padding: 8px; border-bottom: 1px solid #ddd; }
        th { background-color: #f2f2f2; }
        section { page-break-after: always; break-after: page;}
    </style>`

    let mywindow = window.open('', 'PRINT', 'height=400,width=600');
    mywindow.document.writeln('<html><head><title>' + document.title + '</title>');
    mywindow.document.writeln(style);
    mywindow.document.writeln('</head><body />');
    childDrawerData.educations.map(education => {
      const temp = fillOutTemplate(education);
      const html = renderToString(temp)
     mywindow.document.writeln(html);
    });
    mywindow.document.writeln('</body></html>');
    
    mywindow.document.close();
    mywindow.focus();

    setTimeout(() => {
      mywindow.print();
      mywindow.close();
    }, 2000);
  }

  const getDoc = async () => {
    setIsLoading(true);
    try{
      const res = await axiosInstance.get(`/organizer/yp/downloadYpApprovalDoc?ypId=${childDrawerData.id}`,{
        method:"get",
        responseType:"blob",
      });
      if(res && res.status === 204){
        toast.warning("Dokument odobrenja još nije izdan",{position:toast.POSITION.BOTTOM_RIGHT});
      }else{
        const file = new Blob([res.data]);
        let a = document.createElement("a");
        document.body.appendChild(a);
        let fileUrl = URL.createObjectURL(file);
        a.href = fileUrl;
        a.download = ("temp.pdf")
        a.click();
      }
      }catch(e){
      console.log(e);
    }finally{
      setIsLoading(false);
    }
  }

  return (
    <>
      {isLoading && (
        <>
          {" "}
          <div className="spinner-wrapper"></div> <Spinner as="span" animation="border" size="xl" role="status" aria-hidden="true" variant="secondary" />{" "}
        </>
      )}

      {!hideMenuItems &&  <><br /><br /><SSUMenu /><br /></>}

      <div className="yp-content-wrapper">
        <div>
          {!hideCreateBtn && <NewPlanModal yearPlanType={YEAR_PLAN_TYPE.main}/>}
          {!hideCreateBtn && <NewPlanModal yearPlanType={YEAR_PLAN_TYPE.additional} />}
          <Card.Grid hoverable style={{ textAlign: "center" }} onClick={fetchAllPlansAndOpenDrawer}>
            {fetchBtnTitle ? fetchBtnTitle : "Pregledaj sve"}
          </Card.Grid>
        </div>
          {!hideCreateBtn && <YearPlanDeadlineDetails />}
      </div>
      <Drawer open={isPlansDrawerOpen} onClose={closePlansDrawer} destroyOnClose={true} placement="right" closeable contentWrapperStyle={{width:"30%", minWidth:"206px"}} zIndex={999999}>
        <List dataSource={plansData} bordered renderItem={(plan) => (
          <List.Item key={plan.id} actions={[<Button type="primary" onClick={() => showChildDrawer(plan.id)} key={`a-${plan.id}`}>Godišnji plan</Button>]}>
              <Space direction="vertical">
                <List.Item.Meta avatar={<Avatar style={{backgroundColor:"var(--main-color)"}}>{plan.year}</Avatar>} 
                  description={<Button onClick={() => handleAdditionalBtn(plan)}>Dodatni pojedinačni plan</Button>}
                />
              </Space>
            </List.Item>
        )}/>
        <Drawer title={getDrawerTitle()} open={isChildDrawerOpen} onClose={closeChildDrawer} destroyOnClose={true} contentWrapperStyle={{"width":"70%"}} zIndex={999999} placement="right" closable>
          <YPForm closeForm={closeChildDrawer} setIsLoading={setIsLoading} initialData={childDrawerData} isApprovalAction={isApprovalAction}/>
            <>
              <div style={{display:"flex", justifyContent:"space-evenly"}}> 
                {isApprovalAction && <ApproveModal yearPlan={childDrawerData} setYearPlan={setChildDrawerData} forOrganizer={forOrganizer}/>}
                <Button onClick={printPage} icon={<PrinterOutlined />} style={{width: "200px"}}>Ispis godišnjeg plana</Button>
                <Button onClick={getDoc} icon={<FilePdfOutlined />} style={{width:"200px"}}>Preuzmi rješenje</Button>
              </div>
            </>
        </Drawer>
      </Drawer>
    </>
  );
};

const NewPlanModal = ({yearPlanType}) => {
  const [show, setShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [nextYear] = useState(moment().add(1, "y").format("YYYY."));
  const [typeDependentText] = useState(makeDecision());

  function makeDecision(){
    switch(yearPlanType){
      case YEAR_PLAN_TYPE.main:
        return `Godišnji plan za ${nextYear}`;
      case YEAR_PLAN_TYPE.additional:
        return `Dodatni pojedinačni plan za ${nextYear}`;
    }
  }
  

  const openNewPlanModal = () => {
    setShow(true);
  };

  const closeNewPlanModal = () => {
    setShow(false);
  };

  return (
    <>
      {isLoading && (
        <>
          {" "}
          <div className="spinner-wrapper"></div> <Spinner as="span" animation="border" size="xl" role="status" aria-hidden="true" variant="secondary" />{" "}
        </>
      )}
      <Card.Grid hoverable style={{ textAlign: "center" }} onClick={openNewPlanModal}>
        Kreiraj {typeDependentText}
      </Card.Grid>

      <ModalComponent show={show} onHide={closeNewPlanModal} title={typeDependentText} size="xl" backdrop="static" keyboard={false}>
        <YPForm closeForm={closeNewPlanModal} setIsLoading={setIsLoading} initialData={{...INIT_FORM_DATA, type:yearPlanType}}/>
      </ModalComponent>
    </>
  );
};
